import loadable from '@loadable/component';
import React from 'react';


const ClusterMapLoader = loadable(
  () => import('./ClusterMap'),
  {
    ssr: false,
    fallback: <div className="map-loading">Loading map...</div>,
  }
);

export default ClusterMapLoader;